@if (isLoading()) {
<div class="flex items-center justify-center">
  <app-pan-spinner size="xl"></app-pan-spinner>
</div>
} @if (accessLog()) {
<div class="flex gap-4 py-4">
  <div class="flex-1">
    <h3 class="text-xl font-bold">Branch Users</h3>
    <hr class="mb-1" />

    <ul data-testid="access-log-branch-users">
      @for (item of branchViewers(); track item) {
      <li class="border-l-black border-l-2 pl-1 mb-1" data-testid="access-log-entry">
        <div class="text-sm text-gray-600 italic">{{item.latestAccessDate | date : "long"}}</div>
        <div data-testid="access-log-email">{{item.email}}</div>
      </li>
      }
    </ul>

    @if (branchViewers().length === 0) {
    <p>No history of accessing this incident report.</p>
    }
  </div>

  <div class="flex-1">
    <h3 class="text-xl font-bold">Guest Users</h3>
    <hr class="mb-1" />

    <ul data-testid="access-log-guest-users">
      @for (item of clientViewers(); track item) {
      <li class="border-l-black border-l-2 pl-1 mb-1" data-testid="access-log-entry">
        <div class="text-sm text-gray-600 italic">{{item.latestAccessDate | date : "long"}}</div>
        <div data-testid="access-log-email">{{item.email}}</div>
      </li>
      }
    </ul>

    @if (clientViewers().length === 0) {
    <p>No history of accessing this incident report.</p>
    }
  </div>
</div>
}
